module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"paySecure":"Pay securely with these payment methods","followUs":"Follow us"},"de":{"paySecure":"Sicher zahlen","followUs":"Follow us"}}')
  delete Component.options._Ctor
}
